module.exports = __webpack_public_path__ + "static/media/Publications.e9ac8e61.svg";